<div fxLayout>
  <sbnb-subnav fxFlex="280px" fxHide.lt-md [header]="'OPERATIONS.OPERATIONS' | transloco">
    <sbnb-operations-subnav></sbnb-operations-subnav>
  </sbnb-subnav>

  <main fxFlex class="subnav__exists" [ngClass.lt-md]="{ mobile: true, subnav__exists: false }">
    <app-feature-flag-tabs>
      <sbnb-page-header navTabs>
        <h2>Log</h2>
      </sbnb-page-header>
      <h2>Log</h2>
    </app-feature-flag-tabs>

    <sbnb-helptext-wrapper [area]="'intro'" [pageId]="'ops-logs'"></sbnb-helptext-wrapper>

    <div class="rules__filters-container" fxLayout fxLayoutGap="16px">
      <span fxFlex fxHide.lt-md></span>
      <sbnb-search-bar
        fxFlex.lt-md
        placeholderText="Confirmation code..."
        [initialVal]="searchCriteria"
        (searchChanged)="searchUpdated($event)"></sbnb-search-bar>
    </div>

    <div *ngIf="loading" class="table__no-items">Loading logs...</div>

    <ng-container *ngIf="!loading">
      <sbnb-no-items
        *ngIf="!logs || logs?.length === 0"
        icon="log"
        text="No logs found matching these filters"></sbnb-no-items>

      <div *ngIf="logs && logs.length > 0" class="rules__container">
        <a
          *ngFor="let log of logs"
          fxLayout
          class="rules__rule-container"
          fxLayoutAlign="start center"
          fxLayoutGap="16px"
          [routerLink]="['/operations/log/' + log.uuid]">
          <sbnb-icon
            *ngIf="log.status === logStatus.Sent"
            icon="check"
            class="grass-darker"
            [matTooltip]="'Sent successfully'"></sbnb-icon>
          <img
            *ngIf="
              log.status === logStatus.Cancelled || log.status === logStatus.Failed || log.status === logStatus.Bounced
            "
            [matTooltip]="log.status | humanize"
            src="/assets/iconography/delete.svg" />
          <img
            *ngIf="log.status === logStatus.Scheduled"
            [matTooltip]="'Scheduled'"
            src="/assets/iconography/nav-rule-manager.svg" />
          <div fxHide.lt-md fxFlex class="rule__title ellipsis">
            <strong>{{ log.ruleset }}</strong>
          </div>

          <div fxHide.gt-sm class="rule__title ellipsis cera-heading" fxFlex>
            {{ log.ruleset }}
            <br />
            <span class="text__small mobile__event-short">{{ log.mate.name }}</span>
          </div>

          <div fxHide.lt-md fxFlex class="rule__when" fxLayoutAlign="start center" fxLayoutGap="16px">
            <span class="text__small" fxFlex fxLayout fxLayoutGap="12px">
              <strong>{{ log.mate.name }}</strong>
              <span *ngIf="log.mate.services.length > 0" class="team__role text__xsmall strong">
                {{ log.mate.services.join(', ') }}
              </span>
            </span>
          </div>
          <span fxFlex class="text__xsmall">{{ log.confirmation_code }}</span>
          <span fxFlex class="text__xsmall" [matTooltip]="log.scheduled_for_tooltip" fxLayoutAlign="end center">
            {{ log.scheduled_for_label }}
          </span>
        </a>
      </div>
    </ng-container>

    <sbnb-pagination
      *ngIf="paginationData && !loading && paginationData.page_numbers.total_pages > 1"
      position="end"
      [pageCount]="paginationData.page_numbers.total_pages"
      [currentPage]="paginationData.page_numbers.this_page"
      (pageChanged)="handlePageChanged($event)"></sbnb-pagination>
  </main>
</div>

<sbnb-mobile-sidebar [navTabsHide]="true" [title]="'Operations'">
  <sbnb-operations-subnav></sbnb-operations-subnav>
</sbnb-mobile-sidebar>
